import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAlGroupsForDropdown,
    getDivisionByEstateID,
    GetAllOperationEntityByGroupID,
    GetSundrySummaryWorkDistributionData
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetEveryDivisionsFromOperationEntitiyID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return divisionArray;
}

async function GetSundrySummaryWorkDistributionData(data) {
    var model = {
        groupID: data.groupID,
        estateID: data.estateID,
        collectionPointID: data.divisionID,
        month: data.month + "-01",
        year: data.year
    };
    const response = await CommonPost('/api/SundrySummaryWorkDistributionReport/GetSundrySummaryWorkDistributionData', null, model);
    console.log("response.data", response.data)
    return response.data;
}

